import axios from 'axios';

export default {
  all(params = {}) {
    return axios.get('/articles/promoted', {params});
  },
  listAllArticle(params = {}) {
    return axios.get('/articles', {params});
  },
  detail(id: string | number, params = {}) {
    return axios.get(`/articles/${id}`, {params});
  },
  create(payload = {}) {
    return axios.post('/articles/promoted', payload);
  },
  activeStatus(id: string | number) {
    return axios.patch(`/articles/promoted/${id}/active-inactive`);
  },
  useProduct(id: string | number) {
    return axios.patch(`/articles/promoted/${id}/use-product`);
  },
  // delete(id: string | number) {
  //   return axios.delete(`/articles/${id}`);
  // },
  attachProduct(id: string | number, payload = {}) {
    return axios.post(`/articles/promoted/${id}/products`, payload);
  },
  articleProduct(id: string | number, params = {}) {
    return axios.get(`/articles/promoted/${id}/products`, {params});
  },
  attactDelete(id: string | number, params = {}) {
    return axios.delete(`/articles/promoted/${id}/products`, {params});
  },
};
